import React from 'react';

import SimpleContainer from '../../containers/simplecontainer/SimpleContainer';
import CategoryContainer from '../../containers/categorycontainer/CategoryContainer';
import QuotesList from '../../components/quotes-list/quotes-list';

import 'bootstrap/dist/css/bootstrap.css';
import '../../../ext/font-awesome-4.7.0/css/font-awesome.css';

import { PageText, Categories } from '../../input-text/en/help-and-guides/the-silent-killer_page';

class TheSilentKiller extends React.Component {

  render(){
    return (
      <div>
        <SimpleContainer color='dark' containerClass='header-container padded-container'>
          <div className='col-sm-4 hidden-xs header-image-container'>
            <i className="icon fa fa-frown-o fa-5x" aria-hidden="true"></i>
          </div>
          <div className='col-xs-12 col-sm-8 header-info'>
            <h1>{PageText._1}</h1>
            <p>{PageText._2}</p>
          </div>
        </SimpleContainer>
        <CategoryContainer cols='1' category={ Categories._1 } />
        <CategoryContainer cols='1' category={ Categories._2 } component={ <QuotesList quotes={Categories._2.quotes} /> } />
      </div>
    );
  }
};

export default TheSilentKiller;



// WEBPACK FOOTER //
// ./src/routes/help-and-guides/TheSilentKiller.js